<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasTradeStatusType="true"
      :hasReportSourceType="true"
      :hasCostType="true"
      :hasStore="true"
      :hasEmployee="true"
      :hasTerminal="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :hasRankType="true"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    >
      <div class="row" v-if="chartData.rows.length > 0" slot="middleArea">
        <div class="col-md-6">
          <div class="card card-table card-body">
            <ve-histogram :data="chartData" :settings="chartSettings" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="card card-table card-body">
            <ve-pie :data="chartData"></ve-pie>
          </div>
        </div>
      </div>
    </condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      columns: [
        { name: "FoodMajorKindNumber" },
        { name: "FoodMajorKindName" },
        { name: "Qty" },
        { name: "Total" },
        { name: "TotalCost" },
        { name: "NTaxPrice" },
        { name: "ZTaxPrice" },
      ],
      chartSettings: {
        labelMap: {
          Qty: "數量",
          Total: "金額",
        },
        axisSite: { right: ["Total"] },
        yAxisType: ["normal", "KMB"],
        yAxisName: ["數量", "金額"],
      },
      chartData: {
        columns: ["FoodMajorKindName", "Qty", "Total"],
        rows: [],
      },
    };
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getFoodMajorKindStatistic(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getFoodMajorKindStatistic(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printFoodMajorKindStatistic(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getFoodMajorKindStatistic(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
        vm.chartData.rows = data.Datas;
      });
    },
  },
};
</script>
